import React, { useRef, useState } from 'react'
import Carousel from 'react-multi-carousel'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Product from './Product';
import ProductQuickViewModal from '../PlpSection/ProductQuickViewModal';
import AddToCartSuccessModal from '../PlpSection/AddToCartSuccessModal';
import AddShoppingListModal from '../PlpSection/AddShoppingListModal';

const FeaturedProductSlider = (props) => {

    const [containerObject, setContainerObject] = useState(props.containerObject ? props.containerObject : "");
    const [title, setTitle] = useState(props.containerObject && props.containerObject.attributes && props.containerObject.attributes.title ? props.containerObject.attributes.title : "")
    const [currentSlide, setCurrentSlide] = useState(0);
    const carouselRef = useRef(null);

    const [productDetailsObj, setproductDetailsObj] = useState('')
  const [cartProductDetails, setCartProductDetails] = useState('')
  const [productCount, setProductCount] = useState('')

    const handleQuickViewProductPage = (event) => {
        event.preventDefault()
        setproductDetailsObj()
        // props.productCountCallBack("")
        // props.productDetailsCallBack("")
        var formData = new FormData(event.target);
        const productId = formData.get("productIdss")
        const productCount = formData.get("productCount")
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res !== null) {
                    //setIsLoading(false)
                    //	setProductDetailsView(res)
                    var productDetatils = (JSON.parse(res.response)).response
                    setproductDetailsObj(productDetatils)
                    setProductCount(productCount ? productCount : "")
                    document.getElementById("hiddenSharePageModal").click()
                } else {
                    //setIsLoading(false)
                    //const error = res._ERROR_MESSAGE_;
                    //setErrorMessage(error);
                    //document.getElementById("login-message-error-div").classList.remove("d-none");
                    // console.log("errorMessage ---->>>>!!!!", errorMessage)
                }
            })
    }

    const cartProductDetailsCallBack = (productDetails) => {
        setCartProductDetails(productDetails)
      }

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 3,
        },
    };




    const handlePrevious = () => {
        setCurrentSlide(currentSlide - 1);
        carouselRef.current.previous();
    };

    const handleNext = () => {
        setCurrentSlide(currentSlide + 1);
        carouselRef.current.next();
    };

    return (
        <div className=''>
            <div className='col-md-12'>
                <div className="d-flex m-3">                    
					<h2 class="swiper-panel-heading">{title}</h2>
                    {containerObject.results.length > responsive.desktop.items == true ?
                        <div className='col-2 d-none d-lg-block'>
                            <button className={`cb-previous-button mx-4 ${currentSlide === 0 ? 'disabled' : ''}`} onClick={handlePrevious} disabled={currentSlide === 0}>
                                <svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
                            </button>
                            <button className={`cb-next-button ${currentSlide >= containerObject.results.length - responsive.desktop.items ? 'disabled' : ''}`} onClick={handleNext} disabled={currentSlide >= containerObject.results.length - responsive.desktop.items}>
                                <svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
                            </button>
                        </div> : ""}
                </div>
            </div>
            <Carousel
                ref={carouselRef}
                swipeable={false}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                // autoPlaySpeed={2000}
                keyBoardControl={true}
                removeArrowOnDeviceType={["desktop"]}
                deviceType="desktop"
                className='custom-carousel'
                itemClass="custom-item-class"
            >

                {containerObject.results.map((featuredItem,index) => {
                    return (
                        <>
                            <div class={`${containerObject && containerObject.attributes && containerObject.attributes.colPerRowSizeForGridView ? containerObject.attributes.colPerRowSizeForGridView : "col-6 col-md-3"}`}>
                                <div class="c-feature-product qv-model"  >
                                    <Link to={featuredItem["productUrl"]} class="c-product-link">
                                        <img fetchpriority="high" alt="Insect Display Case" src={`https://www.carolina.com${featuredItem["product.smallImageUrl"]}` ? `https://www.carolina.com${featuredItem["product.smallImageUrl"]}` : ""} class="c-product-img" />
                                        <h3 class="cb-product-title" dangerouslySetInnerHTML={{ __html: featuredItem["product.productName"] ? featuredItem["product.productName"] : "" }}>

                                        </h3>
                                    </Link>
                                    <div className="">
                                        {featuredItem["product.familyProduct.count"] ? <p class="c-product-total">{featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""}&nbsp; products</p> : featuredItem["product.productId"] ? <p class="c-product-total">Item #{featuredItem["product.productId"] ? featuredItem["product.productId"] : ""}</p> : ""}
                                        <p class="c-product-price">
                                            {featuredItem.itemPrice ? featuredItem.itemPrice : ""}
                                        </p>
                                    </div>
                                    <div class="c-product-rating">
                                    </div>
                                    <Link id="hiddenSharePageModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></Link>
                                    <form onSubmit={handleQuickViewProductPage} className="" id={`quickViewModalForm${index}`}>
                                        <input type="hidden" name="productIdss" value={featuredItem["product.productId"]} id={`productObj${index}`} />
                                        <input type="hidden" name="productCount" value={featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""} id={`productObj${index}`} />
                                        <button type="submit" className="btn quick-btn modal-link" >Quick View</button>
                                    </form>
                                </div>
                            </div>
                        </>
                    )
                })}
                {/* <Product containerObject={containerObject ? containerObject : ""}/> */}
            </Carousel>

            <ProductQuickViewModal productObj={productDetailsObj} solrValue={productCount} cartProductDetailsCallBack={cartProductDetailsCallBack} />
            <AddToCartSuccessModal productId={productDetailsObj && productDetailsObj.familyProduct && productDetailsObj.familyProduct.productId ? productDetailsObj.familyProduct.productId : ""} quantity={cartProductDetails && cartProductDetails.quantity} productName={cartProductDetails && cartProductDetails.productName} />
            <AddShoppingListModal productId={productDetailsObj && productDetailsObj.familyProduct && productDetailsObj.familyProduct.productId ? productDetailsObj.familyProduct.productId : ""} />
        </div>

    )
}

export default FeaturedProductSlider